<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Кратко' : 'Подробно'" :expandable="items.length > 0">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        <div v-html="formatCountLicenses">
        </div>
      </div>
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show = "isLoaded">

        <template v-for="item in lowItems">
          <div>
            <div>
              <b>
              <a @click="dialogOpen(item)">
              {{item.number}} </a> </b> от {{formats.blank(item.issued.date, formats.formatDate)}}
              
            </div>
            <v-flex pl-2>
              <div><b>{{item.activities.map(a => a.name).join(', ')}}</b>
              </div>
              <div>{{item.issued.org}}</div>
            </v-flex>
          </div>

       </template>
      </div>
    </v-card-text>
    
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'
  import vPanelTitle from './PanelTitle'
  import vLicenseForm from './LicenseForm'
  import dialogs from '../common/dialogs'

  export default {
    name: 'v-licenses-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      items: {
        type: Array,
        default () {
          return []
        }
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        renderDateSince: 'renderDateSince'
      }),
      lowItems () {
        return this.items.slice(0, 20)
      },
      formatCountLicenses () {
        return ''.concat(
          'Лицензий всего ',
          this.items ? this.items.length : 0
          )
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' р.' : ''
      },
      sortItems (a, b) {
        var result = 0
        if (!result) {
          result = new Date(a.issued.date).getTime() - new Date(b.issued.date).getTime()
        }
        return result
      },
      fetchItems () {
        this.items.sort((a, b) => this.sortItems(a, b))
      },
      dialogOpen: function (item) {
        dialogs.register('v-license-form', vLicenseForm)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-license-form v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-license-form>
        `,
          data () {
            return {
              model: item,
              fullscreen: fullscreen
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// LonerLicensesPanel.vue?7735af3c